<div class="modal-header">
  <h4 class="fw-semibold modal-title text-center">
    {{ "Change Company" | translate }}
  </h4>

  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body">
  <form class="text-start mb-3">
    <div class="mb-3">
      <select2-wrapper
        [label]="'Company' | translate"
        [data]="companies"
        [formControl]="company_idControl"
        [isSubmitted]="submit"
        [defaultValue]="company_idControl.value"
      />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()">
    {{ "Close" | translate }}
  </button>
  <button (click)="updateCompany()" class="btn btn-primary" type="button">
    @if (isLoading) {
    <span
      class="spinner-grow spinner-grow-sm me-1"
      role="status"
      aria-hidden="true"
    ></span>
    {{ "Changing" | translate }}
    } @else {
    {{ "Change Company" | translate }}
    }
  </button>
</div>
